import { __decorate, __extends } from "tslib";
import { Validate } from "Login/Decorator/Validator";
import { Execute } from "Login/Decorator/Executor";
import { Serializable } from "Login/FormValidator";
import { Isset, NotNull } from "Login/Validators/BasicValidators";
import { PasswordRepeatValidator } from "Login/Validators/PasswordRepeatValidator";
import { BirthdateValidator } from "Login/Validators/BirthdateValidator";
var Credentials = /** @class */ (function (_super) {
    __extends(Credentials, _super);
    function Credentials() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serialID = "Credentials";
        return _this;
    }
    __decorate([
        Validate(Isset, { groups: ['submit', 'validate'] }),
        Validate(NotNull, { groups: ['submit'], message: 'validation.password.empty' })
    ], Credentials.prototype, "password", void 0);
    __decorate([
        Validate(NotNull, { groups: ['submit'], message: 'validation.passwordRepeat.empty' })
    ], Credentials.prototype, "passwordRepeat", void 0);
    return Credentials;
}(Serializable));
export { Credentials };
var Birthdate = /** @class */ (function (_super) {
    __extends(Birthdate, _super);
    function Birthdate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serialID = "Birthdate";
        _this.isValid = false;
        _this.date = '';
        return _this;
    }
    __decorate([
        Validate(Isset, { groups: ['submit', 'validate'] }),
        Validate(NotNull, { groups: ['submit'], message: 'validation.birthdate.empty' })
    ], Birthdate.prototype, "day", void 0);
    __decorate([
        Validate(Isset, { groups: ['submit', 'validate'] }),
        Validate(NotNull, { groups: ['submit'], message: 'validation.birthdate.empty' })
    ], Birthdate.prototype, "month", void 0);
    __decorate([
        Validate(Isset, { groups: ['submit', 'validate'] }),
        Validate(NotNull, { groups: ['submit'], message: 'validation.birthdate.empty' })
    ], Birthdate.prototype, "year", void 0);
    return Birthdate;
}(Serializable));
export { Birthdate };
var RegistrationRequest = /** @class */ (function (_super) {
    __extends(RegistrationRequest, _super);
    function RegistrationRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.serialID = "Registration";
        _this.credentials = new Credentials();
        _this.birthdate = new Birthdate();
        _this.newsletter = false;
        _this.newsletterCheckbox = "";
        return _this;
    }
    __decorate([
        Execute(function (target, value) { target['password'] = value.password; }),
        Validate(PasswordRepeatValidator, { groups: ['submit', 'validate'] })
    ], RegistrationRequest.prototype, "credentials", void 0);
    __decorate([
        Execute(function (target, value) { value.isValid ? target['birthdate'] = value.date : void 0; }),
        Validate(BirthdateValidator, { groups: ['submit', 'validate'] })
    ], RegistrationRequest.prototype, "birthdate", void 0);
    __decorate([
        Validate(Isset, { groups: ['submit', 'validate'] }),
        Validate(NotNull, { groups: ['submit'], message: 'validation.firstName.empty' })
    ], RegistrationRequest.prototype, "firstName", void 0);
    __decorate([
        Validate(Isset, { groups: ['submit', 'validate'] }),
        Validate(NotNull, { groups: ['submit'], message: 'validation.email.empty' })
    ], RegistrationRequest.prototype, "email", void 0);
    __decorate([
        Validate(Isset, { groups: ['submit', 'validate'] }),
        Validate(NotNull, { groups: ['submit'], message: 'validation.rulesNotAccepted' })
    ], RegistrationRequest.prototype, "rulesAccepted", void 0);
    return RegistrationRequest;
}(Serializable));
export { RegistrationRequest };
